import { ErrorModal } from "@/components/modals/ErrorModal";
import { ConfirmModal } from "@/components/modals/ConfirmModal";
import { EditUser } from "@/pages/Dashboard/Adminstration/Users/EditUser";
import { AddUser } from "@/pages/Dashboard/Adminstration/Users/AddUser";
import { EditNetworkType } from "@/pages/Dashboard/Structures/EditNetworkType";
import { AddEditOrganization } from "@/pages/Dashboard/Backoffice/Organizations/AddEditOrganization";
import { AssignOrganizations } from "@/pages/Dashboard/Backoffice/Users/AssignOrganizations";
import { SetPrimaryOrganization } from "@/pages/Dashboard/Backoffice/Users/SetPrimaryOrganization";
import { ChangePassword } from "@/pages/Dashboard/Backoffice/Users/ChangePassword";
import { AlarmWizard } from "@/pages/Dashboard/Alarms/AlarmWizard";
import { EditStructurePropertyModal } from "@/pages/Dashboard/Structures/Properties/EditStructurePropertyModal";
import { AddOrUpdateStructureProperty } from "@/pages/Dashboard/Structures/Properties/AddOrUpdateStructureProperty";
import { StructurePropertiesWizard } from "@/components/modals/StructurePropertiesWizard";
import { EnableIAndIModal } from "@/components/modals/EnableIAndIModal";
import { DisableIAndIModal } from "@/components/modals/DisableIAndIModal";
import { NoteFilePreview } from "@/pages/Dashboard/Structures/Structure/Notes/Note/NoteFile/NoteFilePreview";

export const modalRegistry = {
	alert: {
		error: ErrorModal,
	},
	dialog: {
		confirm: ConfirmModal,
		editUser: EditUser,
		addUser: AddUser,
		editNetworkType: EditNetworkType,
		addOrganization: AddEditOrganization,
		assignOrganizations: AssignOrganizations,
		setPrimaryOrganization: SetPrimaryOrganization,
		changePassword: ChangePassword,
		alarmWizard: AlarmWizard,
		editStructureProperty: EditStructurePropertyModal,
		addOrUpdateStructureProperty: AddOrUpdateStructureProperty,
		structurePropertiesWizard: StructurePropertiesWizard,
		enableIAndI: EnableIAndIModal,
		disableIAndI: DisableIAndIModal,
		notePreview: NoteFilePreview,
	},
} as const;
